import React from 'react';
import { DataSourceDetail } from '../features/datasources';

/**
 * DataSourceDetailPage - Admin data source detail page
 */
export const DataSourceDetailPage: React.FC = () => {
  return <DataSourceDetail />;
};

export default DataSourceDetailPage;
